import { render, staticRenderFns } from "./FareConditionsTable.vue?vue&type=template&id=23b6c7e8&scoped=true&"
import script from "./FareConditionsTable.vue?vue&type=script&lang=js&"
export * from "./FareConditionsTable.vue?vue&type=script&lang=js&"
import style0 from "./FareConditionsTable.vue?vue&type=style&index=0&id=23b6c7e8&lang=scss&scoped=true&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b6c7e8",
  null
  
)

export default component.exports